import React from "react";

const TruckIcon = () => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>BA3D3175-82A1-4D7E-A806-D7CF0966C4CE</title>
            <g id="Outdated-UI-Kit" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="UI-Kit" transform="translate(-678.000000, -4562.000000)" fill="#1D2758" fillRule="nonzero">
                    <g id="icon_Truck" transform="translate(678.000000, 4562.000000)">
                        <path
                            d="M7.05855756,4 L7.05855756,6.08673874 L4.94098182,6.08673874 C3.7641744,6.08673874 3.29435493,7.23429478 3.11789028,7.65204324 L2.53005126,9.21734775 L2.35358661,9.21832625 C1.35324383,9.21832625 0.588940164,9.89629094 0.588940164,10.7836308 L0.588940164,11.827501 L0,11.8265225 L0,13.9132613 L2.35248547,13.9132613 C2.35248547,15.0608173 3.41127334,16 4.70497095,16 C5.99866855,16 7.05745642,15.0608173 7.05745642,13.9132613 L12.9392348,13.9132613 C12.9392348,15.0608173 13.9980227,16 15.2917203,16 C16.5854179,16 17.6442057,15.0608173 17.6442057,13.9132613 L19.9966912,13.9132613 L20,4 L7.05855756,4 Z M4.39377508,7.88880293 C4.54133155,7.48896956 4.78757378,7 5.23024317,7 L7,7.00083315 L7,9 L4,9 L4.39377508,7.88880293 Z"
                            id="Shape"
                            transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000)"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(TruckIcon);
